// gloss
export const PAGINATION_WIRE_NAMES = {
  page: {
    data: 'data',
    pagination: 'pagination',
    page: 'page',
    pageSize: 'pageSize',
    total: 'total',
    totalPages: 'totalPages',
  },
  cursor: {
    data: 'data',
    pagination: 'pagination',
    cursor: 'cursor',
    pageSize: 'pageSize',
    nextCursor: 'nextCursor',
    hasMore: 'hasMore',
  },
} as const;
